module.exports = __webpack_public_path__ + "media/2.1_comparative_superiority_caroline_cf1.3411d39f.wav";